import { Container } from '@pixi/react'
import { useState } from 'react'
import { AnimatedSprite } from './AnimatedSprite'
import { Button } from '../UI/Button'
import { Image } from '../UI/Image'

interface SpinButtonProps {
  x: number
  y: number
  width: number
  height: number
  isSpinning: boolean
  onSpin: () => void
  onSpinning: () => void
  durationInSeconds?: number
  enabled: boolean
}

export const SpinButton = ({
  durationInSeconds = 1.5,
  ...props
}: SpinButtonProps) => {
  const [parentHover, setParentHover] = useState(false)

  return (
    <Container
      x={props.x}
      y={props.y}
      onmouseenter={() => setParentHover(true)}
      onmouseleave={() => setParentHover(false)}
    >
      <Button
        name="spin button"
        x={0}
        y={0}
        enabled={props.enabled}
        visible={true}
        width={props.width}
        height={props.height}
        defaultView="btnSpinNormal"
        hoverView="btnSpinHover"
        disabledView="btnSpinDisabled"
        pressedView="btnSpinPressed"
        onPressing={() => {
          // remove play sound , each game implement different logic
        }}
        onPress={props.isSpinning ? props.onSpinning : props.onSpin}
      />
      {
        props.isSpinning && props.enabled
          ? (
              <Image
                image="btnSpinIconStop"
                x={props.width / 2}
                y={props.height / 2}
                anchor={0.5}
              />
            )
          : null
      }

      {
        props.enabled
          ? (
              <AnimatedSprite
                image="spinCircle"
                hoverImage="spinCircleHover"
                x={props.width / 2}
                y={props.height / 2}
                width={props.width}
                height={props.height}
                isSpinning={props.isSpinning}
                durationInSeconds={props.isSpinning ? 0.7 : durationInSeconds}
                parentHover={parentHover}
              />
            )
          : null
      }
    </Container>
  )
}
